import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from 'simple-react-modal';
import classnames from 'classnames';
import { withRouter } from 'react-router-dom';
import { Copy, Button, ShareLink, LinkItem, Loader, TextInput, Spinner } from 'elements';
import { Wrapper, Main, Footer, ProfileHeader } from 'components';
import { generateUuid } from 'util/uuid';
import { getUserData, saveLink, editLink, deleteLink } from 'actions/user';

import styles from './profile.scss';

class Profile extends Component {
  state = {
    copied: false,
    showModal: false,
    title: '',
    titleError: '',
    url: 'http://',
    urlError: '',
    linkId: '',
    isSaving: this.props.linkActionStart,
    isDeleting: this.props.deleteLinkStart,
    editingMode: false,
  };

  componentWillMount() {
    const { getUserData, match } = this.props;
    const username = match.params.username;

    getUserData(username);
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.linkActionStart !== this.state.isSaving) {
      this.setState({ isSaving: nextProps.linkActionStart });
    }

    if (nextProps.deleteLinkStart !== this.state.isDeleting) {
      this.setState({ isDeleting: nextProps.deleteLinkStart });
    }

    if (nextProps.linkActionComplete) {
      this.setState({
        showModal: false,
        editingMode: false,
        title: '',
        url: 'http://',
      });
    }
  }

  handleOpenAddLink = () => {
    this.setState({ showModal: true });
  };

  handleOpenEditLink = ({ title, url, id }) => {
    this.setState({
      showModal: true,
      editingMode: true,
      title: title,
      url: url,
      linkId: id,
    })
  };

  handleCancel = () => {
    this.setState({
      showModal: false,
      editingMode: false,
      title: '',
      titleError: '',
      url: 'http://',
      urlError: '',
    });
  };

  handleEditLink = () => {
    const { title, url, linkId } = this.state;
    const { editLink } = this.props;

    if (!this.isValidURL(url)) {
      this.setState({ urlError: 'Please enter a valid website URL' });

      return;
    }

    if (!title) {
      this.setState({ titleError: 'Please enter the title' });

      return;
    }

    editLink(title, url, linkId);
  };

  handleSaveLink = () => {
    const { title, url } = this.state;
    const { saveLink } = this.props;
    const linkId = generateUuid();

    if (!this.isValidURL(url)) {
      this.setState({ urlError: 'Please enter a valid website URL' });

      return;
    }

    if (!title) {
      this.setState({ titleError: 'Please enter the title' });

      return;
    }

    saveLink(title, url, linkId);
  };

  handleDelete = () => {
    const { linkId } = this.state;
    const { deleteLink } = this.props;

    deleteLink(linkId);
  };

  isValidURL = (url) => {
    const isValid = /^(http|https):\/\/[^ ",]+$/.test(url);

    return (!(!url || !isValid));
  };

  handleTitleChange = ({ target }) => {
    this.setState({
      titleError: '',
      title: target.value
    });
  };

  handleURLChange = ({ target }) => {
    this.setState({
      urlError: '',
      url: target.value
    });
  };

  handleCopy = () => {
    this.setState({ copied: true });
  };

  renderSavedLinks () {
    const { savedLinks, isOwner } = this.props;

    if (savedLinks) {
      return savedLinks.map(link => {
        return (
          <LinkItem
            key={link.id}
            href={link.url}
            isOwner={isOwner}
            link={link}
            onClick={() => this.handleOpenEditLink(link)}
          >
            {link.title}
          </LinkItem>
        )
      })
    }
  }

  renderShareLink () {
    const { match } = this.props;
    const username = match.params.username;

    return `${window.location.host}/${username}`;
  }

  renderModal () {
    const { showModal, title, titleError, url, urlError, isSaving, isDeleting, editingMode } = this.state;
    const hasTitleError = !!titleError;
    const hasUrlError = !!urlError;

    return (
      <Modal
        className={styles.modalWrapper}
        closeOnOuterClick={true}
        show={showModal}
      >
        <Copy className={styles.modalLabel} type="label">title</Copy>
        <TextInput
          placeholder=" "
          value={title}
          onChange={this.handleTitleChange}
          error={hasTitleError}
        />
        {titleError &&
          <Copy type="inputError">
            {titleError}
          </Copy>
        }
        <Copy className={classnames(styles.modalLabel, styles.urlLabel)} type="label">url</Copy>
        <TextInput
          placeholder=" "
          value={url}
          onChange={this.handleURLChange}
          error={hasUrlError}
        />
        {urlError &&
          <Copy type="inputError">
            {urlError}
          </Copy>
        }
        {editingMode &&
          <Button
            className={styles.deleteButton}
            onClick={this.handleDelete}
            disabled={isDeleting}
            secondary
          >
            <Spinner inButton visible={isDeleting} />
            <span>Delete this link</span>
          </Button>
        }
        <div className={styles.ctaButtonWrapper}>
          <Button onClick={this.handleCancel} muted>Cancel</Button>
          <Button
            onClick={editingMode ? this.handleEditLink : this.handleSaveLink}
            primary
            disabled={isSaving}
          >
            <Spinner inButton visible={isSaving} />
            <span>{editingMode ? 'Update' : 'Add'}</span>
          </Button>
        </div>
      </Modal>
    )
  }

  render () {
    const { copied } = this.state;
    const { imgSrc, name, username, isFetchingUser, userFetchError, showTooltip, isOwner } = this.props;

    return (
      <div>
        {
          isFetchingUser ? (
            <Wrapper>
              <Main>
                <Loader />
              </Main>
            </Wrapper>
          ) : (
            <Wrapper>
                {userFetchError
                  ?
                  <Copy type="error">{userFetchError}</Copy>
                  :
                  <ProfileHeader
                    avatarSrc={imgSrc}
                    name={name}
                    username={username}
                    isOwner={isOwner}
                    showTooltip={showTooltip}
                    onClick={this.handleOpenAddLink}
                  />
                }
              <Main className={styles.main}>
                <div className={styles.scroller}>
                  {this.renderSavedLinks()}
                </div>
              </Main>
              {isOwner &&
                <Footer className={styles.footer}>
                  <ShareLink shareLink={this.renderShareLink()} copied={copied} onCopyClick={this.handleCopy} />
                </Footer>
              }
              {this.renderModal()}
            </Wrapper>
          )
        }
      </div>
    )
  }
}

const ProfileWithRouter = withRouter(Profile);

export default connect(state => ({
  imgSrc: state.user.userPhoto,
  userId: state.user.userId,
  name: state.user.name,
  username: state.user.username,
  isFetchingUser: state.user.isFetchingUser,
  userFetchError: state.user.userFetchError,
  linkActionStart: state.user.linkActionStart,
  linkActionError: state.user.linkActionError,
  linkActionComplete: state.user.linkActionComplete,
  deleteLinkStart: state.user.deleteLinkStart,
  savedLinks: state.user.savedLinks,
  showTooltip: state.user.showTooltip,
  isOwner: state.user.isOwner,
}), { getUserData, saveLink, editLink, deleteLink })(ProfileWithRouter);



// WEBPACK FOOTER //
// ./src/pages/profile/profile.js